import React from 'react'
import {Link} from 'react-router-dom'

import KwotaLogo from '../KwotaLogo'
import ErrorProps from './types'

const defaultErrorMessage = 'Sorry, we couldn’t find the page you’re looking for.'
const PageNotFound = ({errorMessage = defaultErrorMessage, redirectURL = '/'}: ErrorProps) => {
  return (
    <main className="flex items-center justify-center w-full h-full min-h-screen px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
      <div className="flex-col flex-grow">
        <div className="flex justify-center flex-shrink-0">
          <span className="sr-only">KWOTA</span>
          <KwotaLogo
            className="block w-auto h-12 cursor-pointer"
            url={redirectURL}
          />
        </div>
        <div className="py-16">
          <div className="text-center">
            <p className="text-base font-semibold font-titillium text-kwota-primary">404</p>
            <h1 className="mt-2 text-4xl font-bold tracking-tight font-titillium text-kwota-neutral-800 sm:text-5xl">
              Page not found.
            </h1>
            <p className="mt-2 text-base font-titillium text-kwota-neutral-500">{errorMessage}</p>
            <div className="mt-6">
              <Link
                to={redirectURL}
                className="text-base font-medium font-titillium text-kwota-primary"
              >
                Go back home
                <span aria-hidden="true"> &rarr;</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}

export default PageNotFound
